<!-- <div class="flex flex-col p-4 border-[#c5c5c5] border-[1px] bg-white">
  <div class="flex flex-row gap-1">
    <p class="text-[#8A8A8A] font-bold text-base">Actividad: </p>
    <p class="text-[#8A8A8A] text-base">{{ bookedService.service}} </p>
  </div>
  <div class="flex flex-row gap-1">
    <p class="text-[#8A8A8A] font-bold text-base">Fecha:</p>
    <p class="text-[#8A8A8A]  text-base">{{formatDate(bookedService.date)}}</p>
  </div>
  <div class="flex flex-row gap-1">
    <p class="text-[#8A8A8A] font-bold text-base">Hora:</p>
    <p class="text-[#8A8A8A]  text-base"> {{ bookedService.hour }}</p>
  </div>
  <div class="flex flex-row gap-1">
    <p class="text-[#8A8A8A] font-bold text-base">Adultos:</p>
    <p class="text-[#8A8A8A] text-base mr-2">{{ bookedService.seats !== undefined && bookedService.seats !== null ? bookedService.seats : 0 }} </p>
    <p class="text-[#8A8A8A] font-bold text-base">Menores:</p>
    <p class="text-[#8A8A8A] text-base">{{ bookedService.seatsKids !== undefined && bookedService.seatsKids !== null ? bookedService.seatsKids : 0  }}</p>
  </div>
  <div class="flex flex-row gap-1">
    <p class="text-[#8A8A8A] font-bold text-base">Equipación reservada:</p>
    <p class="text-[#8A8A8A] text-base">{{ bookedService.itemService}}</p>
  </div>
  <div class="flex flex-row gap-1">
    <p class="text-[#8A8A8A] font-bold text-base">Zona:</p>
    <p class="text-[#8A8A8A] text-base"></p>
  </div>
  <div class="flex flex-row justify-between gap-1">
    <div>
      <p class="text-[#8A8A8A] font-bold text-base">Importe:</p>
      <p class="text-[#8A8A8A] text-base">{{ bookedService.totalAmount}}</p>
    </div>
    <div class="flex flex-row gap-4 align-middle items-center">
      <button (click)="editService()" class="h-4 w-4 p-1" pInputText pTooltip="Editar">
        <i class="pi pi-pencil" style="font-size: 1rem" style="color: #27368A"></i>
      </button>
      <button (click)="deleteService()" class="h-4 w-4 p-1" pInputText pTooltip="Eliminar">
        <i class="pi pi-times" style="font-size: 1rem" style="color: red"></i>
      </button>
    </div>
  </div>
</div> -->
<div class="flex flex-row gap-4 align-middle items-center">
  <button (click)="editService(index)" class="h-4 w-4 p-1" pInputText pTooltip="Editar">
    <i class="pi pi-pencil" style="font-size: 1rem" style="color: #27368A"></i>
  </button>
  <button (click)="deleteService()" class="h-4 w-4 p-1" pInputText pTooltip="Eliminar">
    <i class="pi pi-times" style="font-size: 1rem" style="color: red"></i>
  </button>
</div>

<form [formGroup]="formService" (ngSubmit)="saveService()">
<p-dialog *ngIf="formServiceEdit" header="Header" [modal]="true" [(visible)]="formServiceEdit" [style]="{width: '35vw'}">
  <ng-template pTemplate="header">
    <h4 class="text-[#27368A] font-extrabold text-xl">Datos de la actividad</h4>
  </ng-template>
  <div class="grid grid-cols-1 gap-1 justify-center align-middle  mb-0 h-min box-content">
      <div class="mb-2">
            <label for="" class="text-[#27368A] font-bold text-base" >Seleccionar actividad: </label>
              <select tabindex="1"
              class="flex align-middle items-center  bg-white rounded-lg w-full h-9 px-2  text-black font-medium text-base border-[rgb(39,54,138)] border-2">
              <option value="">-</option>
              <ng-container *ngFor="let service of services; let i = index" >
              <option [value]="i" class="bg-white  hover:bg-[#27368A]">{{ service.name }}
                </option>
              </ng-container>
              </select>
          </div>
          <div class="mb-2" *ngIf="userSelectedService !== undefined">
            <label for="" class="text-[#27368A] font-bold text-base" >Seleccionar perfil: </label>
              <select formControlName="service" tabindex="2"  [ngClass]="{'border-red-600' : formService.get('service')?.touched && formService.get('service')?.hasError('required')}"
              class="flex align-middle items-center  bg-white rounded-lg w-full h-9 px-2  text-black font-medium text-base border-[#27368A] border-2">
                <option [value]="i"  *ngFor="let profile of userSelectedService.profiles; let i = index" class="bg-white  hover:bg-[#27368A]">{{ profile?.name }}
                </option>
              </select>
            <div *ngIf="formService.controls['service'].touched">
              <p *ngIf="formService.get('service')?.hasError('required')" class="text-red-600 text-xs font-bold">Campo obligatorio</p>
            </div>
          </div>
      <div class="flex flex-row gap-4">
        <div class="flex flex-col">
          <label for="date" class="text-[#27368A] font-bold text-base">Seleccionar fecha: </label>
          <input formControlName="date" type="date" id="date" tabindex="3"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-[165px] mb-2">
        </div>
        <div class="flex flex-col">
          <label for="date" class="text-[#27368A] font-bold text-base">Seleccionar hora: </label>
          <select formControlName="hour" tabindex="4"
            class="flex align-middle items-center  bg-white rounded-lg w-[165px] h-10 px-2  text-black font-medium text-base border-[#27368A] border-2 mb-2">
            <option value="" disabled selected></option>
            <option [value]="hour" *ngFor="let hour of hours" class="bg-white  hover:bg-[#27368A]">{{ hour }}</option>
          </select>
        </div>
      </div>
      <p class="text-[#27368A] font-bold text-base">Seleccionar plazas: </p>
      <div class="flex flex-row gap-5 mb-2">
        <div class="flex flex-col gap-1 ">
          <label for="" class="text-[#27368A] font-semibold text-sm flex align-top items-start ">Adultos: </label>
            <input formControlName="units" type="number" value="0" id="units" tabindex="5"
            (change)="calculateAmountService()"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-[165px] ">
        </div>
      </div>
      <div class="flex flex-row gap-1">
        <label class="text-[#27368A] font-bold text-lg">Importe total: </label>
        <p class="text-[#8A8A8A] font-bold text-lg">{{ formService.value.totalAmount | currency: 'EUR' }} </p>
      </div>
      <label for="" class="text-[#27368A] font-bold text-base mt-0 ">Notas:</label>
        <textarea formControlName="notes" id="Textarea" tabindex="6" name="Textarea" rows="2" cols="25"
        class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-84 mb-2 mt-0"></textarea>
      <div class="flex justify-end">
        <button
          class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-6 hover:bg-[#27368A]" (click)="saveService()">Guardar</button>
      </div>
    </div>
  </p-dialog>
</form>
